import styled, { css } from "styled-components";
import OutlinedCard from "../../surface/OutlinedCard/OutlinedCard";

export const FormGridRoot = styled(OutlinedCard)(
    () => css`
        width: 100%;
    `,
);
